import { render } from "./lists-detail.view.vue?vue&type=template&id=b1ae2260&scoped=true&ts=true"
import script from "./lists-detail.view.vue?vue&type=script&lang=ts"
export * from "./lists-detail.view.vue?vue&type=script&lang=ts"

import "./lists-detail.view.vue?vue&type=style&index=0&id=b1ae2260&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ae2260"]])

export default __exports__